import LoaderIconGreen from '@images/icons/loader-icon-green.svg?react'
import LoaderIcon from '@images/loader-icon.svg?react'

import './CoreLoader.scss'

type CoreLoaderProps = {
  color?: 'red' | 'green'
}

const CoreLoader = ({ color = 'red' }: CoreLoaderProps) => (
  <div className='core_loader'>
    {color === 'red' && <LoaderIcon />}
    {color === 'green' && <LoaderIconGreen />}
  </div>
)

export default CoreLoader
